import React from 'react';
import { useEffect } from 'react';


//Zoho Sales Iq Script:
const useScript = (url, widgetCode) => {
    useEffect(() => {
    // const script = document.createElement('script');
    // script.setAttribute("type", "text/javascript");
    // script.setAttribute("id", "zsiqchat")
    // let code = `var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode: "${widgetCode}", values:{},ready:function(){}};var d=document;s=d.createElement("script");s.type="text/javascript";s.id="zsiqscript";s.defer=true;s.src="${url}";t=d.getElementsByTagName("script")[0];t.parentNode.insertBefore(s,t);d.innerHTML = "<div id='zsiqwidget'></div>";`
    
    // script.appendChild(document.createTextNode(code));
    // document.body.appendChild(script);

    window.$zoho = window.$zoho || {};
    window.$zoho.salesiq = window.$zoho.salesiq || { widgetcode: widgetCode, values: {}, ready: function() {} };

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "zsiqscript";
    script.defer = true;
    script.src = "https://salesiq.zoho.com/widget";
    document.getElementsByTagName("head")[0].appendChild(script);

    return () => {
    //  document.body.removeChild(script);
        script.remove();
    }
}, [url]);
};

export default function SalesIQ() {
    return (
        <React.Fragment>
            {useScript('https://salesiq.zoho.com/widget', 'siq5646794e061e7eb48a0645092742466bd9f385b3d29d83c4e62e2d5e8074861b')}
        </React.Fragment>
    );
}
